<template xmlns="http://www.w3.org/1999/html">
  <td :class="[worklogsView ? 'project-td text-nowrap' : 'first-column text-nowrap']">
    <span :class="[worklogsView ? 'project-name' : '']">{{ projectName }}<i class="fa fa-external-link action"
        @click="$router.push({ name: 'ProjectTabPlanning', params: { id: projectId } });" aria-hidden="true"></i></span>
  </td>
</template>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'ProjectCell',
  props: ['projectId', 'worklogsView'],
  computed: {
    projectName() {
      return this.$store.state.JiraProjects.projects[this.projectId].name;
    }
  },
  methods: {
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.action {
  margin-left: 5px;

  &:hover {
    cursor: pointer;
    color: #ee0044;
  }
}

.project-name {
  padding-left: 30px;
}

.project-td {
  min-width: 200px;
  width: 200px;
  /*position: absolute;*/
  position: sticky;
  position: -webkit-sticky;
  left: 0;
  z-index: 1;
}

.first-column {
  position: sticky;
  position: -webkit-sticky;
  left: 0;
  z-index: 1;
  background: white;
}
</style>
